import React from "react";
import "./Portfolio.scss";
import PortfolioCard from "./PortfolioCard";
import {Container} from "react-bootstrap";

const Portfolio = () => {
  const portfolioCardArray = [
    {
      title: "1 People",
      category: "CaaS | Denmark & USA",
      stake: '94.77%',
      roi: '245%',
      status: 'Seed',
      highlight: false,
      logo: '1People.png',
      url: 'https://1people.com',
      details:
        "1 People offers a wellness and health-focused subscription, where members enjoy the benefits of a safe and motivational community with activities for body, mind and soul along with curated sustainable products at exclusive member pricing.",
    },
    {
      title: "FairMedia",
      category: "Digital Media & Publishing | USA",
      stake: '100%',
      roi: '900%',
      status: 'Seed',
      highlight: false,
      logo: 'FairMedia.png',
      url: 'https://thefairmedia.com/',
      details:
          "FairMedia is a digital media publishing network that connects brands with highly engaged audiences through a curated portfolio of high-authority websites. It enables businesses to build visibility, credibility, and market authority through editorial content, PR distribution, and SEO-driven amplification. By combining premium publishing with strategic storytelling, FairMedia helps brands reach targeted audiences at scale while delivering measurable impact across digital channels.",
    },
    {
      title: "DoLand",
      category: "Fintech | Denmark",
      stake: '10.26%',
      roi: '182%',
      status: 'Seed',
      highlight: false,
      logo: 'DoLand.png',
      url: 'https://dolandpro.com',
      details:
          "DoLand is a fintech company offering a B2B SaaS platform for impact investment reporting and advisory. It enables banks, family offices, and wealth managers to measure and communicate the real-world impact of their portfolios through automated, data-driven insights aligned with global frameworks such as the SDGs and EU Taxonomy. By transforming complex data into clear, actionable reporting and advisor tools, DoLand enhances client engagement and supports better investment decisions, with a mission to make impact transparent, measurable, and scalable.",
    },
    {
      title: "Valified",
      category: "Fintech | Denmark",
      stake: '16.96%',
      roi: '17%',
      status: 'Seed',
      highlight: false,
      logo: 'Valified.png',
      url: 'https://www.valified.com/',
      details:
          "Valified is a data intelligence platform that enables companies and financial institutions to collect, manage, and leverage ESG and business data through a unified digital solution. It simplifies sustainability documentation, CO₂ calculations, and compliance requirements while transforming complex data into actionable insights, benchmarks, and professional reports. By providing clear visibility into performance, risks, and growth potential, Valified supports better decision-making for businesses and enhances credit assessment and advisory capabilities for financial institutions, driving more transparent and data-driven sustainable growth.",
    },
    {
      title: "Artelize",
      category: "AI Tech, SaaS, Entertainment | Denmark",
      stake: '7.98%',
      roi: '100%',
      status: 'Seed',
      highlight: false,
      logo: 'Artelize.png',
      url: 'https://artelize.com/',
      details:
          "Artelize is an AI Tech, SaaS, and Entertainment platform transforming the performing arts ecosystem by enhancing discovery, audience engagement, and data-driven decision-making. It serves as a global hub for events, artists, and venues across genres such as opera, orchestral, ballet, theatre, and jazz, enabling users to explore and access performances worldwide. Beyond discovery, Artelize provides a SaaS solution for performing arts organizations that converts ticketing and audience data into actionable insights, driving attendance, retention, and revenue growth. By combining content, data, and AI-driven analytics, Artelize aims to increase visibility, accessibility, and sustainable growth across the global performing arts industry.",
    },
    {
      title: "Wennick-Lefèvre",
      category: "Natural and Ethical Gem Stones | Denmark",
      stake: '50%',
      roi: '50%',
      status: 'Seed',
      highlight: false,
      logo: 'WL.png',
      url: 'https://www.wennicklefevre.com/',
      details:
          "Wennick-Lefèvre is a Copenhagen-based ethical gemstone company specializing in natural, untreated sapphires sourced primarily from artisanal mines in Madagascar and Sri Lanka. They maintain full traceability from mine to market, with rough stones cut at their partner facility, Sunrise Facets, in Sri Lanka. Only 1% of sapphires in jewellery are truly natural and untreated — Wennick-Lefèvre exclusively deals in these rare gems. They run a 'one tree for one stone' reforestation initiative in Madagascar and co-founded the Copenhagen Commitment movement to promote ethical practices across the jewellery industry.",
    },
    // {
    //   title: "FairShop.com",
    //   category: "E-Commerce, Tech and Logistics | USA",
    //   stake: '100%',
    //   roi: '2900%',
    //   status: 'Pre-Seed',
    //   highlight: 'green',
    //   logo: 'FairShop.png',
    //   url: false,
    //   details:
    //       "Farishop.com is gearing up to be a game-changer in e-commerce. Our focus is on offering sustainable products to global consumers, an automated global storage & logistics with fast and cheap handling and shipping. With the world increasingly embracing sustainability, we're entering the market in 2023 at the perfect time. Farishop.com isn't just an online store; it's a commitment to conscious consumption and sustainability. Join us on this exciting journey!",
    // },
    // {
    //   title: "Fair Business Growth",
    //   category: "Business Service | USA",
    //   stake: '100%',
    //   roi: '1900%',
    //   status: 'Pre-Seed',
    //   highlight: 'green',
    //   logo: 'FairBusinessGrowth.png',
    //   url: 'https://fairbusinessgrowth.com',
    //   details:
    //       "Fair Business Growth focus on bridging the gap between dreams and reality for companies. A marketplace and agency that is dedicated to helping companies achieve their aspirations through comprehensive 360-degree services. They are offering solutions covering sales, performance ads, organic content, accounting, PR, strategic market analysis, tech, funding, and manufacturing.",
    // },
    // {
    //   title: "Business For Planet",
    //   category: "Educational | Denmark",
    //   stake: '$000',
    //   roi: '$000',
    //   status: 'Pre-Seed',
    //   highlight: 'green',
    //   details:
    //     "Business for Planet provides complimentary training and mentoring of entrepreneurs and people who want to become one from all over the world. Alongside the mentoring, BFP is also a safe place to connect and network internationally with a diversified range of impact driven entrepreneurs. ",
    // },
    // {
    //   title: "Nordic Bridge Impact",
    //   category: "Service | Denmark",
    //   stake: '$000',
    //   roi: '$000',
    //   madeAnExit: 1,
    //   details:
    //     "Nordic Impact Bridge is based on a philosophy that co-creation is the best way to create market standards. That's why we invite all relevant partners on board, so that together we can create a perfect match between the most talented and promising small and medium-sized enterprises in the Nordic region and their need for capital and skills.",
    // },
    {
      title: "Love Nature Superfoods",
      category: "Food, Ingredients | United Kingdom",
      stake: '52.5%',
      roi: '108%',
      status: 'Exit',
      highlight: 'yellow',
      logo: 'LoveNature.png',
      url: 'https://www.lovenaturesuperfoods.com/',
      details:
          "Love Nature Superfoods is one of the leading organic whole-food trading companies in Europe, sourcing and supplying high-quality organic, plant-based, and gluten-free ingredients directly from origin to customer warehouses. Their product range includes organic chia seeds, quinoa, sesame seeds, coconut derivatives, plant-based proteins, and gluten-free flours. They are IFS certified and focused on making organic ingredients more widely available and affordable across the market.",
    },
    {
      title: "Concordium",
      category: "Blockchain, Crypto | Switzerland",
      stake: 'CCD',
      roi: '-84%',
      status: 'Exit',
      highlight: 'yellow',
      logo: 'Concordium.png',
      url: 'https://www.concordium.com/',
      details:
          "Concordium is a Layer-1 blockchain protocol with built-in identity verification at the protocol level, now positioning itself as trust infrastructure for the agentic economy. Its tagline, 'Verified Humans. Verified Agents. One Protocol,' reflects a focus on enabling verified transactions between users, businesses, and AI agents using zero-knowledge proofs for privacy-preserving compliance. Key offerings include stablecoin issuance, tokenized money market funds, PayFi solutions, geofencing, and one-click age verification.",
    }
  ];

  //portfolioCardArray = [portfolioCardArray[0]];

  return (
    <Container fluid={true}>
      <Container className={'mb-5'}>
        <div className="about-us2 mw-100 text-uppercase text-center my-5 py-5">
          OUR <br /> Portfolio
        </div>
        <div className="portfolio-header w-75 mx-auto my-5">
          <p>
            The companies inside Impact Business Investment Group all have different focuses and serve different needs. But they all have one thing in common - they aim to make the world a better place through their business ideas and initiatives.
          </p>
        </div>
      </Container>
      <Container className={'mt-5 px-5 portfolio-items'}>
        {portfolioCardArray.map((portfolioCard, index) => (
            <PortfolioCard portfolioCard={portfolioCard} key={index} />
        ))}
      </Container>
    </Container>
  );
};

export default Portfolio;
